var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8199 5.88886H12.5533C12.5133 5.56392 12.3133 5.23898 12.0266 5.07997L6.99992 2.43207L1.86659 5.07997C1.54659 5.25972 1.33325 5.63997 1.33325 6.00639V11.4197C1.33325 12.1802 1.93325 12.8024 2.66659 12.8024V6.1654L6.99992 3.81478L10.8199 5.88886Z",
    fill: "#54708C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.58022H4.66659C3.93325 6.58022 3.33325 7.20244 3.33325 7.96293V14.1852C3.33325 14.9456 3.93325 15.5679 4.66659 15.5679H13.3333C14.0666 15.5679 14.6666 14.9456 14.6666 14.1852V7.96293C14.6666 7.20244 14.0666 6.58022 13.3333 6.58022ZM13.3333 14.1852H4.66659V9.34565L8.99992 11.6479L13.3333 9.34565V14.1852ZM8.99992 10.2652L4.66659 7.96293H13.3333L8.99992 10.2652Z",
    fill: "#54708C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letterIcon.3c6e3587048c095590feb60467af3175.svg";
export { ForwardRef as ReactComponent };